import { Dispatch, SetStateAction, createContext, useState } from 'react';
import { useGetTenantQuery } from '@/hooks/useGetTenantQuery';
import { LANGUAGE } from '@/enums';

interface Language {
  language: string | null;
  setLanguage: Dispatch<SetStateAction<string | null>>;
  isLoading: boolean;
  supportedLanguages: string[];
}

export const LanguageContext = createContext<Language>({} as Language);

export const LanguageProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const [language, setLanguage] = useState(localStorage.getItem('i18nextLng'));

  const { tenant, isFetching } = useGetTenantQuery();

  const supportedLanguages: string[] = tenant?.dbConfig?.organization
    ?.supportedLanguages ?? [LANGUAGE.EN];

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage,
        supportedLanguages,
        // isLoading: !!!subdomain,
        isLoading: isFetching,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
